import React from 'react';
import Typography from '@mui/material/Typography';
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';

const theme = createTheme();
const useStyles = makeStyles()(() => ({
   container: {
      width: '100%',
      height: '100%',
      display: 'table',
      verticalAlign: 'middle'
   },
   item: {
      verticalAlign: 'middle',
      display: 'table-cell'
   }
}));

function NoDataDiv({className, typographyProps}) {
   const {classes, cx} = useStyles();
   return (
      <div className={cx(classes.container, className)}>
         <Typography variant="h5" className={classes.item} align="center" {...typographyProps}>
            No existen datos para mostrar
         </Typography>
      </div>
   );
}

export default NoDataDiv;
